import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, Box, Button } from '@mui/material';

const AddDocumentDialog = ({ open, onClose, onSubmit, loading, error }) => {
  const [name, setName] = useState('');
  const [localError, setLocalError] = useState('');

  useEffect(() => {
    if (!open) {
      setName('');
      setLocalError('');
    }
  }, [open]);

  const handleSubmit = () => {
    if (!name.trim()) {
      setLocalError('Document name is required');
      return;
    }
    setLocalError('');
    onSubmit(name);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add Document</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Document Name"
          fullWidth
          value={name}
          onChange={e => setName(e.target.value)}
          disabled={loading}
          error={!!localError || !!error}
          helperText={localError || error}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button onClick={onClose} disabled={loading}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained" color="primary" disabled={loading} sx={{ ml: 2 }}>
            {loading ? 'Adding...' : 'Add'}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AddDocumentDialog; 